import type { BoardToolDef, BoardToolId } from "./types";

export const BOARD_TOOL_REGISTRY: BoardToolDef[] = [
  {
    id: "select",
    title: "Курсор — выделение и перенос (V). ПКМ или средняя кнопка — сдвиг холста; два пальца на тачпаде — прокрутка",
    shortcut: "V",
    enabled: true,
  },
  {
    id: "hand",
    title: "Рука — сдвиг холста (H)",
    shortcut: "H",
    enabled: true,
  },
  {
    id: "pen",
    title: "Ручка — свободный штрих (P)",
    shortcut: "P",
    enabled: true,
  },
  {
    id: "line",
    title: "Линия — отрезок (L)",
    shortcut: "L",
    enabled: true,
  },
  {
    id: "arrow",
    title: "Стрелка (A)",
    shortcut: "A",
    enabled: true,
  },
  {
    id: "shape",
    title: "Фигуры — прямая, стрелка, прямоугольник… (R)",
    shortcut: "R",
    enabled: true,
  },
  {
    id: "frame",
    title: "Рамка — раздел урока (F)",
    shortcut: "F",
    enabled: true,
  },
  {
    id: "text",
    title: "Текст (T)",
    shortcut: "T",
    enabled: true,
  },
  {
    id: "sticky",
    title: "Стикер (N)",
    shortcut: "N",
    enabled: true,
  },
  {
    id: "eraser",
    title: "Ластик — стереть штрихи (E)",
    shortcut: "E",
    enabled: true,
  },
];

export const ENABLED_BOARD_TOOLS = BOARD_TOOL_REGISTRY.filter((t) => t.enabled);

export function boardToolById(id: BoardToolId): BoardToolDef | undefined {
  return BOARD_TOOL_REGISTRY.find((t) => t.id === id);
}
